/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SetupPauseModal_run$ref: FragmentReference;
declare export opaque type SetupPauseModal_run$fragmentType: SetupPauseModal_run$ref;
export type SetupPauseModal_run = {|
  +id: string,
  +machine: {|
    +id: string,
    +type: {|
      +id: string,
      +name: string,
    |},
  |},
  +$refType: SetupPauseModal_run$ref,
|};
export type SetupPauseModal_run$data = SetupPauseModal_run;
export type SetupPauseModal_run$key = {
  +$data?: SetupPauseModal_run$data,
  +$fragmentRefs: SetupPauseModal_run$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SetupPauseModal_run",
  "type": "Run",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "machine",
      "storageKey": null,
      "args": null,
      "concreteType": "Machine",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "type",
          "storageKey": null,
          "args": null,
          "concreteType": "MachineType",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '54ce30e2150a81f49f12ab70bf3d36e6';
module.exports = node;
